import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Bermuda: Country = {
    identifier: "Bermuda",
    name: "Bermuda",
    countryCode: "BM",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇧🇲",
    svgPath: "m 293.23075,367.6474 -0.252,0.112 -0.07,-0.009 -0.05,-0.038 0.257,-0.112 0.215,-0.262 0.074,0.017 z",
}
